import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from '../base-api.service';
import { Airport } from '../../model/airport';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AirportService extends BaseApiService<Airport, number> {
  protected endpoint = '/airport';

  constructor(protected override http: HttpClient) {
    super(http);
  }

  getPublicAirportByCode(code: string) {
    return this.http.get(`${environment.apiUrl}/public/airport/${encodeURIComponent(code)}`);
  }
}
